export const SET_USER = "SET_USER"
export const LOGOUT = "LOGOUT"